import { render, staticRenderFns } from "./tatics-preview.vue?vue&type=template&id=58c3d893&scoped=true"
import script from "./tatics-preview.vue?vue&type=script&lang=ts"
export * from "./tatics-preview.vue?vue&type=script&lang=ts"
import style0 from "./tatics-preview.vue?vue&type=style&index=0&id=58c3d893&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c3d893",
  null
  
)

export default component.exports